import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/.pnpm/lucide-react@1.67.0_@types+react@19.3.0_react@19.3.1/node_modules/lucide-react/dist/esm/Icon.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/.pnpm/next-intl@4.14.9_@swc+helpers@0.5.23_@types+react@19.3.0_next@16.4.5_@babel+core@7.29.7_acb4625394aa3638cacfe6c4008e1f28/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@16.4.5_@babel+core@7.29.7_@opentelemetry+api@1.9.1_@types+node@24.19.2_react-dom@19.3.1_react@19.3.1__react@19.3.1/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["Image"] */ "/app/node_modules/.pnpm/next@16.4.5_@babel+core@7.29.7_@opentelemetry+api@1.9.1_@types+node@24.19.2_react-dom@19.3.1_react@19.3.1__react@19.3.1/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["InAppBrowserBanner"] */ "/app/src/checkout/components/in-app-browser-banner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AuthProvider","saleorAuthClient"] */ "/app/src/lib/auth/auth-provider.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/ui/atoms/link-with-channel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CampaignBoundary"] */ "/app/src/ui/components/black-friday/campaign-boundary.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CampaignCountdown"] */ "/app/src/ui/components/campaign-countdown.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CampaignExpiry"] */ "/app/src/ui/components/campaign-expiry.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CartButton"] */ "/app/src/ui/components/cart/cart-button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CartProvider","useCart"] */ "/app/src/ui/components/cart/cart-context.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/ui/components/cart/cart-drawer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CheckoutPromptModal"] */ "/app/src/ui/components/cart/checkout-prompt-modal.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CopyrightText"] */ "/app/src/ui/components/copyright-text.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FooterLocaleRegionControls"] */ "/app/src/ui/components/footer-locale-region-controls.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["InquiryForm"] */ "/app/src/ui/components/footer/inquiry-form.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NewsletterSignup"] */ "/app/src/ui/components/footer/newsletter-signup.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HeaderScrollShadow"] */ "/app/src/ui/components/header-scroll-shadow.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LocaleChannelProvider"] */ "/app/src/ui/components/locale-channel/locale-channel-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LocaleChannelDropdown"] */ "/app/src/ui/components/nav/components/locale-channel-dropdown.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MobileMenu"] */ "/app/src/ui/components/nav/components/mobile-menu.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NavHoverDropdown"] */ "/app/src/ui/components/nav/components/nav-hover-dropdown.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NavLink"] */ "/app/src/ui/components/nav/components/nav-link.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SearchToggle"] */ "/app/src/ui/components/nav/components/search-toggle.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["UserMenu"] */ "/app/src/ui/components/nav/components/user-menu/user-menu.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/app/src/ui/components/ui/toaster.tsx");
